import { isRequired, maxLength, minLength } from 'utils/validate/validate';

export const validationsProtocoloSearch = dadosInputs => {
  const { protocolo, documento } = dadosInputs;
  const errosCampos = {
    protocolo: null,
    documento: null,
  };

  errosCampos.documento = isRequired(documento) || minLength(documento, 14) || maxLength(documento, 18);
  errosCampos.protocolo = isRequired(protocolo);
  return errosCampos;
};
